











































































































import Component from 'vue-class-component';
import Vue from 'vue';
import { MasterPage } from '@/components/base/master/master-page';
import * as ent from '@/entities';
import SaleLogsCriteriaComponent, {
    ISaleLogsCriteria
} from './sale-logs-criteria.vue';
import saleLogsApi from '@/api/sale-logs.api';
import store from '@/store/store';
import * as types from '@/store/types';
import {mapGetters} from 'vuex';

@Component({
    components: {
        'sale-logs-criteria': SaleLogsCriteriaComponent
    },
    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class SaleLogs extends MasterPage {
    public items: ent.ISaleLogsItemModel[] = [];
    public earningVisible: boolean = false;
    public timer: any = null;

    public showForJessy: boolean = store.getters[types.AUTH_HAS_PERMISSION_JESSE];

    protected defaultSort: ent.ISort = {
        field: 'date',
        asc: false
    };

    get moneyColVisible() {
        return this.earningVisible;
    }

    private getModel: ISaleLogsCriteria = null;

    public list(body: ent.ISearchBody): Promise<ent.IPaging<any>> {
        throw new Error('Not supported');
    }

    public getSaleLogs() {
        this.loading = true;
        let body: ent.IGetSaleLogsModel = {
            ...this.getModel,
            ...this.pageSortParams()
        };
        saleLogsApi.saleLogs(body)
            .then((response: ent.ISaleLogsModel) => {
                this.loading = false;
                this.items = response.items.items;
                this.earningVisible = response.earningVisible;
                if (response.items.total !== null) {
                    this.total = response.items.total;
                }
            })
            .catch((err) => console.warn(err));
    }

    public startTimer() {
        this.timer = setInterval(() => {
            this.getSaleLogs();
        }, 60 * 1000);
    }

    public stopTimer() {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
    }

    public beforeDestroy() {
        this.stopTimer();
    }

    // todo: refactor -> remove dublication
    protected search(model: ISaleLogsCriteria) {
        this.getModel = model;

        this.getSaleLogs();
        this.stopTimer();
        this.startTimer();
    }
}
